<template>
    <academic>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="courseyears"
                          :is-ajax="true"
                          :searchlink="route('academic.courseyear.list')"
                          :action="{'text':'add course year','url':route('academic.courseyear.create')}"
                          :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Course Year')"
                          :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Course Year')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                <template #duration="data">
                    {{data.item.duration.start_month}} - {{data.item.duration.end_month}}
                </template>
                <template #course="data">
                    {{data.item.course.title}} - {{data.item.course.course_type.title}}
                </template>
                <template #action="data">
                    <button-link :href="route('academic.courseyear.batch.list',data.item.id)" class="mr-2" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Course Year')">Batches</button-link>
                    <button-link :href="route('academic.courseyear.semester.list',data.item.id)" class="mr-2" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Course Year')">Semesters</button-link>
                    <button-link :href="route('academic.courseyear.edit',data.item.id)"  v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Course Year')">Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink
        },
        props:['courseyears'],
        data(){
            return{
                fields:[{'key':'title','label':'Title'},{'key':'duration','label':'Duration'},{'key':'course','label':'Course'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]
            }
        }
    }
</script>
